import { render, staticRenderFns } from "./add-case-tel-record.vue?vue&type=template&id=3e8084d6&scoped=true"
import script from "./add-case-tel-record.vue?vue&type=script&lang=ts"
export * from "./add-case-tel-record.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8084d6",
  null
  
)

export default component.exports